import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { MarketplaceType } from "../marketplace-type";
import { useEffectOnce } from "react-use";
import Axios from "axios";
import { MarketplaceListScroll } from "../marketplace-list-scroll";

export const MarketplaceList = ({ macketplaceData }) => {
  const { t, i18n } = useTranslation();
  const [list, setList] = useState(macketplaceData || []);
  const [currentType, setCurrentType] = useState("");
  const [currentTotal, setCurrentTotal] = useState(737);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [typeLoading, setTypeLoading] = useState(false);

  const [searchLock, setSearchLock] = useState(false);

  //   const [moreLoding, setMoreloding] = useState(false);
  //   useEffectOnce(() => {
  //     setLoading(true);
  //     Axios.get("/api/marketplace-list?page=1&category=")
  // >>>>>>> ccae137f69e3a59e3fef9e658bb57ad465c894e1

  useEffectOnce(() => {
    setTypeLoading(true);
    Axios.get("/api/marketplace-category")
      .then((res) => {
        setCategories(res?.data?.data || []);
        setTypeLoading(false);
      })
      .catch((res) => {
        console.log("error" + res);
      });
  });
  return (
    <div className="marketplace-list">
      <div className="inner">
        <MarketplaceType
          setList={setList}
          list={list}
          typeLoading={typeLoading}
          currentType={currentType}
          setCurrentType={setCurrentType}
          currentTotal={currentTotal}
          setCurrentTotal={setCurrentTotal}
          setCategories={setCategories}
          categories={categories}
          setSearchLock={setSearchLock}
        />

        {/* <div className="application-box">
          <div className="application-warp"> */}
        <MarketplaceListScroll
          setList={setList}
          list={list}
          setLoading={setLoading}
          loading={loading}
          currentType={currentType}
          currentTotal={currentTotal}
          searchLock={searchLock}
        />
        {/* </div>
        </div> */}
      </div>
    </div>
  );
};
